
import {scrollToWithHash} from '../components/PageScroll/PageScroll';

export default function() {

  const getQueryObj = () => {
    const parameters = document.location.search.substring(1).split('&');
    const queryObj = new Object();
    for (var i = 0; i<parameters.length; i++) {
      const element = parameters[i].split('=');
      if(element[0] && element[1]){
        queryObj[decodeURIComponent(element[0])] = decodeURIComponent(element[1]);
      }
    }
    return queryObj;
  }

  const openTargetRowWithPid = (callBackOpenTargetRow) => {
    const queryObj = getQueryObj();
    if(!queryObj['pid']) return;
    const targetHash = '#pid-' + queryObj['pid'];
    const parentElement = document.body.querySelector(targetHash);
    if(parentElement){
      if(callBackOpenTargetRow) callBackOpenTargetRow(parentElement);
      scrollToWithHash(targetHash);
    }
  }

  /**
   * WORK ページ
   */
  const filterWorkerList = () => {
    const select = document.querySelector("#archive-work-country");
    //
    select.addEventListener('change', function(){
      let selectedCountry = document.getElementById('archive-work-country');
      let selectedCountryVal = selectedCountry.value;
      location.href = `/work/?country=${selectedCountryVal}`;
    });
  }
  const workPageElement = document.querySelector('.c-sectionHeading__title--works')
  if(workPageElement) {
    filterWorkerList();

    const openWorkRow = (parentElement) => {
      if(!parentElement) return;
      const content = parentElement.querySelector('.info.is-show');
      if(!content) return;
      content.style.height = "auto";
    }
    openTargetRowWithPid(openWorkRow);
  }

  /**
   * NEWS ページ
   */
  const filterNewsList = () => {
    const selectYear = document.querySelector("#archive-news-year");
    const selectCategory = document.querySelector("#archive-news-category");
    //
    const filterNews = () => {
      let selectedYear = document.getElementById('archive-news-year');
      let selectedYearVal = selectedYear.value;
      let selectedCat = document.getElementById('archive-news-category');
      let selectedCatVal = selectedCat.value;
      //
      location.href = `/news/?cat=${selectedCatVal}&y=${selectedYearVal}`;
    }
    //
    selectYear.addEventListener('change', filterNews);
    selectCategory.addEventListener('change', filterNews);
  }

  const newsPageElement = document.querySelector('.c-sectionHeading__title--news')
  if(newsPageElement) {
    filterNewsList();

    const openNewsRow = (parentElement) => {
      if(!parentElement) return;
      const content = parentElement.querySelector('.content');
      if(!content) return;
      content.style.height = "auto";
    }
    openTargetRowWithPid(openNewsRow);
  }

}